import "./style.scss";
import $ from "jquery";

$(document).on('click', '.hero-big__scroll-down', function () {
    var button = $(this);
    $('html, body').animate({
        scrollTop: button.offset().top + 50
    }, 500);
});